module.exports = __webpack_public_path__ + "static/media/FLAC.22764452.svg";